import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { telaIdsToNumber, TelasIds } from "../../../../../common/utils/tela_ids";
import { IGetFuncionariosUseCase } from "../../../presentation/useCases/read/get_funcionarios_use_case";
import { FuncionarioTabela } from "../../models/funcionario_tabela";
import { FuncionarioFilters } from "../../models/funcionarios_filters";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionariosUseCase
 */

export class GetFuncionariosUseCase extends BasePaginatedUseCase<FuncionarioTabela> implements IGetFuncionariosUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getFuncionarios(
    telaId: TelasIds,
    filters: FuncionarioFilters,
    sortField: string,
    sort: "asc" | "desc",
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getFuncionarios(
      telaIdsToNumber(telaId),
      filters,
      sortField,
      sort,
      page,
      pageSize,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}